(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Talwin", [], factory);
	else if(typeof exports === 'object')
		exports["Talwin"] = factory();
	else
		root["Talwin"] = factory();
})(self, function() {
return 